import toCamelCase from './toCamelCase';

const generateColorModifier = (componentName, colorModifier) => `${componentName}--${toCamelCase(colorModifier)}`;

export default generateColorModifier;
